module.exports = __webpack_public_path__ + "static/img/step3.24087d05.jpg";